module.exports = __webpack_public_path__ + "static/media/imagem_epi_gpi.3d037593.png";